<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/mixins";

  .attachment {
    display: flex;
    flex: 0 1 auto;
    align-items: center;
    border-radius: 14px;
    padding: utils.in_rem(6px);
    @include colors.background-color(interfaceTransparentBlack_4);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    a {
      border-radius: 6px;
      padding: 0;
      margin: 0;

      outline-color: colors.get(primary_40);
      &:focus {
        outline: 2px solid colors.get(primary_40);
      }
      display: flex;
      flex: 1 1 auto;
      gap: utils.in_rem(6px);
      align-items: center;
      background-color: transparent;
      padding-right: 6px;

      overflow: hidden;

      .info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-evenly;
        overflow: hidden;

        .name {
          flex: 0 1 auto;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          @include mixins.body2();
        }
        .size {
          @include mixins.body4-badge();
        }
      }
    }
  }
</style>

<script>
  import Tooltip from "../../atoms/Tooltip.svelte";
  import Button from "../../atoms/Button.svelte";
  import IconScale from "../../atoms/IconScale.svelte";

  export let attachmentId;
  export let ondelete;

  import { attachmentsStore } from "../../../../src/svelte/api-stores/attachments-store";

  $: data = $attachmentsStore.find((a) => a.attachmentId === attachmentId) || {
    attachmentId,
  };

  const withSizeUnit = (size = 0) => {
    const units = ["B", "KB", "MB", "GB", "TB"];
    let limit = 1;

    for (const unit of units) {
      if (size < limit * 1000)
        return `${Math.round((size / limit) * 10) / 10}${unit}`; // factor of 10 gives one decimal place
      limit *= 1000;
    }
    throw new Error("How did you manage to upload that?");
  };

  const icon = (filename = "") => {
    const suffix = filename.split(".").pop() || "";
    const ext = suffix.toLowerCase();

    const extMap = {
      pdf: "fa-file-pdf",
      doc: "fa-file-word",
      docx: "fa-file-word",
      xls: "fa-file-spreadsheet",
      xlsx: "fa-file-spreadsheet",
      csv: "fa-file-spreadsheet",
      ppt: "fa-file-powerpoint",
      pptx: "fa-file-powerpoint",
      jpg: "fa-file-image",
      jpeg: "fa-file-image",
      png: "fa-file-image",
      gif: "fa-file-image",
      bmp: "fa-file-image",
      svg: "fa-file-image",
      zip: "fa-file-archive",
      tar: "fa-file-archive",
      gzip: "fa-file-archive",
      txt: "fa-file-lines",
      mp3: "fa-file-audio",
      mp4: "fa-file-video",
      mov: "fa-file-video",
    };
    return extMap[ext] || "fa-file";
  };
  const deleteClick = () => ondelete(attachmentId);

  $: skeleton = !data || !data.filename;
</script>

<div class="attachment" class:skeleton>
  {#if !skeleton}
    <Tooltip let:onmouseenter let:onmouseleave let:onfocus let:onblur>
      <span slot="tooltip">{data.filename || ""}</span>
      <a
        href={data.url}
        target="_blank"
        on:mouseenter={onmouseenter}
        on:mouseleave={onmouseleave}
        on:focus={onfocus}
        on:blur={onblur}
      >
        <IconScale
          size="medium"
          class={icon(data.filename)}
          backgroundColor="interfaceSwGrey_10"
          color="black_90"
        />
        <div class="info">
          <div class="name" class:skeleton>
            {data.filename || data.attachmentId}
          </div>
          <div class="size" class:skeleton>{withSizeUnit(data.size)}</div>
        </div>
      </a>
    </Tooltip>
    <Tooltip let:onmouseenter let:onmouseleave let:onfocus let:onblur>
      <span slot="tooltip">Remove attachment</span>
      <Button
        class="flex-0"
        size="small"
        kind="ghost-grey"
        leadingIcon="fa-trash-can"
        onclick={deleteClick}
        {onmouseenter}
        {onmouseleave}
        {onfocus}
        {onblur}
      />
    </Tooltip>
  {/if}
</div>
